import * as React from 'react'; 
import { any, bool, func, oneOf } from 'prop-types';

import './style.css';
import Button from '../Button';

export default function Dialog({children, title, onConfirm, onCancel, onRequestClose, isOpen, closeOnCancel, width, confirmText, cancelText}){

   if(!isOpen){
      return <div/> 
   }

   const handleOverlayClick = function(){
     onRequestClose()
   }

   const handleCancel = function(){
      if(!closeOnCancel) return;

     onRequestClose();
     onCancel();
   }

   const handleConfirm = function(){
     onConfirm();
   }

  let widthClass = 'w-full md:w-3/5';

  if(width === 'small') widthClass = 'w-full md:w-1/2';
  if(width === 'large') widthClass = 'w-full md:w-3/4';
  if(width === 'xlarge') widthClass = 'w-full md:w-4/5';
   
   return (
     <div className="dialog-wrapper h-screen w-screen fixed overflow-hidden top-0 left-0">
       <div className="dialog-wrapper__overlay bg-black opacity-75 absolute w-full h-full" onClick={handleOverlayClick}></div>
       <div className={`dialog-wrapper__content bg-gray-100 border-white border shadow-xl rounded mx-auto mt-5 relative ${widthClass} flex flex-col`}>
         <h4 className={`text-2xl border-b mb-2 pl-3 px-2 pb-2 ${!title && 'hidden'} border-b mt-2 bg-white`}>
           {title}
         </h4>
         <div className="p-3 flex-1 overflow-auto">
           {children}
         </div>
         <div className="p-2 text-right border-t bg-gray-200">
           <div className="inline-block mr-2">
             <Button onClick={handleConfirm}>
               <span className="text-blue-600 font-bold">
                 {confirmText}
               </span>
             </Button>
           </div>
           <div className="inline-block">
             <Button onClick={handleCancel}>
               {cancelText}
             </Button>
           </div>
         </div>
       </div>
     </div>
   )
}

Dialog.defaultProps = {
  closeOnCancel: true, 
  isOpen: true,
  width: 'medium',
  confirmText: 'Confirm', 
  cancelText: 'Cancel'
}

Dialog.propTypes = {
  children: any,
  title: any,
  onConfirm: func,
  onCancel: func,
  closeOnCancel: bool,
  isOpen: bool,
  onRequestClose: func, 
  width: oneOf(['xlarge', 'large', 'medium', 'small'])
}
